import StorageService from "./storage";
import { setFaroUser, clearFaroUser } from "@/observability/faro";

const ACCESS_TOKEN_KEY = 'at'

type JwtPayload = Record<string, unknown>

interface YarismaciTokenPayload extends JwtPayload {
  yaid?: number | string; // yarışmacı id
  yid?: number | string; // yarışma id
  isim?: string; // yarışmacı ismi
  gkod?: string; // giriş kodu (anket linki {KOD} yer tutucusu için)
}

class JwtService {
  static getAccessToken(): string | null {
    return StorageService.get(ACCESS_TOKEN_KEY)
  }

  static saveAccessTokens(accessToken: string): void {
    StorageService.set(ACCESS_TOKEN_KEY, accessToken)
    // Faro session'ına yarismaci_id'yi bağla.
    const payload = parseJwt<YarismaciTokenPayload>(accessToken)
    if (payload.yaid != null) {
      setFaroUser(String(payload.yaid))
    }
  }

  static destroyTokens(): void {
    StorageService.delete(ACCESS_TOKEN_KEY)
    clearFaroUser()
  }

  static getTokenObj(): YarismaciTokenPayload {
    const token = JwtService.getAccessToken()
    if (!token)
      return {} as YarismaciTokenPayload

    return parseJwt<YarismaciTokenPayload>(token)
  }
}

export type {JwtPayload}
export default JwtService

function parseJwt<T extends JwtPayload>(token: string): T {
  try {
    const base64Url = token.split('.')[1]
    if (!base64Url)
      return {} as T

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    )
    return JSON.parse(jsonPayload) as T
  } catch {
    return {} as T
  }
}
